<template>
  <div>
    <canvas ref="chartCanvas" :style="chartStyle ? chartStyle : { width: '100%', height: '180px' }"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'; // Import Chart.js

export default {
  name: 'ProviderProductionChart',
  props: {
    chartData: Object, // Chart data passed from parent
    chartStyle: Object, // Optional style for the chart container
  },
  data() {
    return {
      chartInstance: null, // Store the Chart.js instance
    };
  },
  methods: {
    createChart(data) {
      // Destroy the existing chart instance if it exists
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      // Get the canvas element
      const ctx = this.$refs.chartCanvas.getContext('2d');

      // Create a new Chart.js instance
      this.chartInstance = new Chart(ctx, {
        type: 'bar', // Use a bar chart
        data: {
          labels: ['On Schedule (Net)', 'Net Production', 'Collection'], // X-axis labels
          datasets: [
            {
              label: 'Value', // Dataset label
              data: [data.data[0].data[0][1], data.data[1].data[0][1], data.data[2].data[0][1]], // Y-axis values
              backgroundColor: ['#a7beff', '#ace5d1', '#FFA45B'], // Bar colors
              borderWidth: 0, // No border
            },
          ],
        },
        options: {
          responsive: true, // Make the chart responsive
          maintainAspectRatio: false, // Allow custom height/width
          legend: {
            display: false, // Hide the legend
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontColor: '#333', // X-axis label color
                },
                gridLines: {
                  display: false, // Hide grid lines for X-axis
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true, // Start Y-axis from 0
                  fontColor: '#333', // Y-axis label color
                },
                gridLines: {
                  color: '#eee', // Light grid lines for Y-axis
                },
              },
            ],
          },
          tooltips: {
            enabled: true, // Enable tooltips
            mode: 'index', // Show tooltips for all datasets at the same index
            intersect: false, // Allow hovering over multiple bars
          },
        },
      });
    },
  },
  mounted() {
    // Create the chart when the component is mounted
    if (this.chartData) {
      this.createChart(this.chartData);
    }
  },
  watch: {
    // Watch for changes in chartData and update the chart
    chartData(newData) {
      if (newData) {
        this.createChart(newData);
      }
    },
  },
  beforeDestroy() {
    // Destroy the chart instance when the component is destroyed
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>